import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown dei caratteri speciali */
@Component({
  selector: 'app-special-char-dropdown',
  templateUrl: './special-char-dropdown.component.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class SpecialCharDropdownComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Elenco dei caratteri speciali disponibili */
  noteList = ['«', '»', 'ś', '“', '”', "‘", "’", "–"]

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit(value);
  }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext () {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };
  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious () {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection () {
    this.changeValue(this.noteList[this.selected]);
  };

  constructor() { }

}
